import { gql } from '@apollo/client'
import {
  multiGameTeamParlayOptionsFragment,
  singleGameBountyOptionsFragment,
  singleGameOptionsFragment,
  singleGameTeamParlayOptionsFragment,
} from './bet-line-option-types'

const betLineFragment = gql`
  fragment BetLineItem on BetLineItem {
    betType
    category
    cost
    title
    lineType
    required
    options {
      ... on SingleGameTeamBountyOption {
        ...SingleGameBountyOptions
      }
      ... on SingleGameTeamOption {
        ...SingleGameOptions
      }
      ... on MultiGameTeamParlayOption {
        ...MultiGameTeamParlayOptions
      }
      ... on SingleGameTeamParlayOption {
        ...SingleGameTeamParlayOptions
      }
    }
  }
  ${singleGameTeamParlayOptionsFragment}
  ${singleGameBountyOptionsFragment}
  ${singleGameOptionsFragment}
  ${multiGameTeamParlayOptionsFragment}
`

const teammateBetRestrictionFragment = gql`
  fragment TeammateBetRestriction on TeammateBetRestriction {
    userId
    gameModeBetRestrictions {
      gameMode
      betRestrictions {
        lockState
        valueId
      }
    }
  }
`

export const teamFragment = gql`
  fragment Team on Team {
    id
    updatedAt
    matchMap
    squadSize
    serviceFee
    gameSlug
    betCategory
    gameMode
    lines {
      ...BetLineItem
    }
    teammateBetRestrictions {
      ...TeammateBetRestriction
    }
  }
  ${betLineFragment}
  ${teammateBetRestrictionFragment}
`
